// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-C":"NA_outdoor-recreation-C__2ow4C"};